/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_Q3Inputs */

const en_pc_dl_faq_q3 = /** @type {(inputs: Pc_Dl_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I install PdfCraft silently on many PCs?`)
};

const zh_pc_dl_faq_q3 = /** @type {(inputs: Pc_Dl_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何在多台电脑上静默安装 PdfCraft？`)
};

/**
* | output |
* | --- |
* | "How do I install PdfCraft silently on many PCs?" |
*
* @param {Pc_Dl_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_q3 = /** @type {((inputs?: Pc_Dl_Faq_Q3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_Q3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_q3(inputs)
	return zh_pc_dl_faq_q3(inputs)
});
export { pc_dl_faq_q3 as "pc.dl.faq.q3" }